// Module
var code = "<div class=\"im-contactinfo\"> <div class=\"im-contactinfo-icon tooltip\"> <span class=\"tooltiptext\">联系方式</span> </div> <div class=\"im-contactinfo-content\"> <ul class=\"im-contactinfo-texts\"> </ul> <div class=\"im-contactinfo-arrow-down\"></div> </div> </div> ";
// Exports
module.exports = code;